import React from 'react';
import Typical from 'react-typical';
import ScrollService from '../../../utilities/ScrollService';

import './Profile.css';

export const Profile = () => {
	return (
		<div className='profile-container'>
			<div className='profile-parent'>
				<div className='profile-details'>
					<div className='colz'>
						<div className='colz-icon'>
							<a
								href='https://www.facebook.com/khang.burn.7'
								target='_blank'
								rel='noopener noreferrer'
							>
								<i className='fa fa-facebook-square'></i>
							</a>
							<a
								href='https://www.instagram.com/nduc_kh/'
								target='_blank'
								rel='noopener noreferrer'
							>
								<i className='fa fa-instagram'></i>
							</a>
							<a
								href='https://github.com/duckhang2210'
								target='_blank'
								rel='noopener noreferrer'
							>
								<i className='fa fa-github'></i>
							</a>
							<a
								href='https://www.linkedin.com/in/duc-khang-nguyen-606b62128/'
								target='_blank'
								rel='noopener noreferrer'
							>
								<i className='fa fa-linkedin-square'></i>
							</a>
						</div>
					</div>

					<div className='profile-details-name'>
						<div className='primary-text'>
							Hello, I'M <span className='highlighted-text'>Duc Nguyen</span>
						</div>
					</div>
					<div className='profile-details-role'>
						<span className='primary-text'>
							<h1>
								<Typical
									loop={Infinity}
									steps={[
										'Full Stack Developer 💻',
										1000,
										'Ethusiastic Dev 🧐',
										1000,
										'Photographer 📷',
										1000,
										'Lifelong Learner 📕',
										1000
									]}
								/>
							</h1>
							<span className='profile-role-tagline'>
								Design and develop full-scaled application of all sizes with
								5-star services.
							</span>
						</span>
					</div>
					<div className='profile-options'>
						<button
							className='btn primary-btn'
							onClick={() => ScrollService.scrollHandler.scrollToHireMe()}
						>
							Hire Me
						</button>
						<a href='Duc Nguyen Resume.pdf' download='Duc Nguyen Resume'>
							<button className='btn highlighted-btn'>Get Resume</button>
						</a>
					</div>
				</div>
				<div className='profile-picture'>
					<div className='profile-picture-background'></div>
				</div>
			</div>
		</div>
	);
};
